import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse, inform, approved } from "../helpers";
import { STRINGS, api } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class CommentMediator extends Mediator {
	$$comment = {
		needs: {
			deletion: (ed, event) => this.deleteComment(ed, event),
			like: (ed, event) => this.likeComment(ed, event),
			unlike: (ed, event) => this.unlikeComment(ed, event),
			reply: (ed, event) => this.send($e.comment.needs.replyForm, ed),

			to: {
				saveReply: (ed, event) => this.saveReply(ed, event),
			},
		},
	};

	async deleteComment(ed, event) {
		if (!approved(event, ed, "Want to delete this comment")) return;

		let { comment } = eParse(ed).message;
		let res = await api.delete(`${routes.comments}/${comment?.id}`);

		if (!res) {
			return this.send($e.comment.has.deletionError, ed);
		}

		inform(res.message, STRINGS.SUCCESS);
		return this.send($e.comment.deleted, ed);
	}

	async likeComment(ed, event) {
		let { comment } = eParse(ed).message;
		let res = await api.post(`${routes.comments}/${comment?.id}/like`);

		if (!res) {
			return this.send($e.comment.has.reactionError, ed);
		}

		return this.send(
			$e.comment.is.liked,
			payload({ comment: res.data.comment })
		);
	}

	async unlikeComment(ed, event) {
		let { comment } = eParse(ed).message;
		let res = await api.delete(`${routes.comments}/${comment?.id}/like`);

		if (!res) {
			return this.send($e.comment.has.reactionError, ed);
		}

		return this.send(
			$e.comment.is.unliked,
			payload({ comment: res.data.comment })
		);
	}

	async saveReply(ed, event) {
		let { commentId, comment } = eParse(ed).message;

		let res = await api.post(`${routes.comments}/${commentId}/comments`, {
			content: comment,
		});

		if (!res) return this.send($e.comment.has.replyError, ed);

		inform(res.message, STRINGS.SUCCESS);

		this.send(
			$e.comment.is.repliedTo,
			payload({ reply: res.data.reply, comment: res.data.comment })
		);
	}
}
